/**
* takes a number and an array of numbers,
* adds or removes the number to the array,
* returns the modified array
*
* @param    {number} value - a number
* @param    {array} criteriaArray - reference to an array of numbers
*
* @returns {array} criteriaArray - the modified original array
*/

const updateCriteriaArray = (value, criteriaReference) => {
  const criteria = criteriaReference

  value.split(',').forEach((val) => {
    const selectedValue = parseInt(val, 10)

    const index = criteria.findIndex(number => number === selectedValue)

    if (criteria.includes(selectedValue)) {
      criteria.splice(index, 1)
    } else {
      criteria.push(selectedValue)
      criteria.sort()
    }
  })
  return criteria
}

export default updateCriteriaArray



// WEBPACK FOOTER //
// ./src/logic/updateCriteriaArray.js